'use strict';

export default {
  errors: {
    generic: 'Une erreur est survenue',
    limitReached: 'Le nombre limite de soumissions est atteinte',
    genericRefresh: 'Une erreur est survenue. Veuillez rafraichir la page et essayer de nouveau.',
    http: {
      400: 'Erreur 400',
      401: 'Erreur 401: Session expirée',
      404: 'Erreur 404: Page introuvable',
      500: 'Erreur 500: Erreur du serveur',
    },
  },
  success: {
    saved: 'Enregistré avec succès',
  },
};
